<script setup lang="ts">
import { getArticleDetail } from "@carnet/api/backoffice";
import type { ArticleResourceDetailed } from "@carnet/api/backoffice";

const { data: article } = await useAsyncData<ArticleResourceDetailed | null>(
  "article-applicationCta",
  async () => {
    const result = await getArticleDetail({ composable: "$fetch", path: { locale: appLocale(), code: "applicationCta" } });
    return result?.data ?? null;
  },
  { getCachedData: cachedDataUnlessRefresh, lazy: true }
);
</script>

<template>
  <AppSectionAppCTA :article="article ?? null">
    <template #picture="{ article: cta }">
      <WebArticlePicture
        :main-image="cta.mainImage?.url"
        :alt="cta.title"
        picture-class="md:absolute size-full"
        img-class="size-full object-contain"
      />
    </template>
  </AppSectionAppCTA>
</template>
